/**
 * ч.811 (рішення власника 2026-09-13): у фізособи може бути КІЛЬКА банківських
 * рахунків (як у контрагента): картка → блок «Рахунки». Основний — дзеркало
 * payout_iban (його бере виплата ЗП за замовчуванням); рахунки також
 * додаються авто з виписок і платіжок. Таблиця — той самий BankTab, що у
 * контрагента (IBAN + назва банку за МФО + «зробити основним»).
 */
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { individualBankAccounts } from '@/api/hr';
import { refs } from '@/api/refs';
import { findBankByIban } from '@/shared/ukr_classifiers';
import { BankTab } from '@/pages/ContractorRelatedTabs';

export default function IndividualBankAccounts({ individualId }: { individualId: string }) {
  const qc = useQueryClient();
  const accQ = useQuery({
    queryKey: ['individual-bank-accounts', individualId],
    queryFn: () => individualBankAccounts.list(individualId),
  });
  const currenciesQ = useQuery({ queryKey: ['currencies'], queryFn: refs.currencies });
  const banksQ = useQuery({ queryKey: ['banks'], queryFn: () => refs.banks() });
  const uahId = (currenciesQ.data ?? []).find((c) => c.code === 'UAH')?.id ?? '';
  const invalidate = async () => {
    await qc.invalidateQueries({ queryKey: ['individual-bank-accounts', individualId] });
    await qc.invalidateQueries({ queryKey: ['individuals'] });
  };
  const rows = (accQ.data ?? []).map((a) => ({
    id: a.id, owner_id: a.individual_id, iban: a.iban, currency_id: uahId,
    account_name: a.account_name, is_main: a.is_main,
  }));
  return (
    <div>
      <label style={{ fontSize: '0.85rem', fontWeight: 600 }}>Банківські рахунки (виплата ЗП — на основний)</label>
      <BankTab
        accounts={rows}
        currencies={(currenciesQ.data ?? []).map((c) => ({ id: c.id, code: c.code }))}
        bankNameByIban={(iban) => findBankByIban(iban, banksQ.data ?? [])}
        onAdd={async (d) => {
          await individualBankAccounts.add(individualId, {
            iban: d.iban, account_name: d.account_name, is_main: d.is_main });
          await invalidate();
        }}
        onRemove={async (id) => { await individualBankAccounts.remove(individualId, id); await invalidate(); }}
        onSetMain={async (id) => {
          const a = (accQ.data ?? []).find((x) => x.id === id);
          if (!a) return;
          await individualBankAccounts.update(individualId, id, {
            iban: a.iban, account_name: a.account_name, is_main: true });
          await invalidate();
        }}
      />
    </div>
  );
}
